import React, { useState } from 'react';
import { reduxForm, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import RenderCustomDeclarations from './RenderCustomDeclarations';
import RenderProducts from './RenderProducts';

import validate from '../validate';

const Title = styled.div`
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 30px;
`;

const ItemsCounter = styled.span`
  margin: 50px;
  position: relative;
  font-size: 15px;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

const useStyles = makeStyles(theme => ({
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  }
}));
/**
 * Composant principale englobant la mise à jour des informations des produits
 * présent dans une commande, et des déclarations douanière
 *
 * @param {Object[]} commands   Toute les commandes importé
 * @param {Number} commandIndex Index de la commande actuelle
 */
let EditCommandItems = ({ commands, commandIndex }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextItems = () => {
    setCurrentIndex(currentIndex + 1);
  };

  const previousItems = () => {
    setCurrentIndex(currentIndex - 1);
  };
  const classes = useStyles();
  return (
    <form>
      <Title>Produit n° {currentIndex + 1} :</Title>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <FieldArray
            name="items"
            component={RenderProducts}
            currentIndex={currentIndex}
          />
        </Grid>
        <Grid item md={6}>
          <FieldArray
            name="customsDeclarations"
            component={RenderCustomDeclarations}
            currentIndex={currentIndex}
          />
        </Grid>
      </Grid>
      <ButtonContainer>
        <Button
          color="primary"
          disabled={currentIndex === 0}
          onClick={previousItems}
        >
          <ChevronLeftIcon className={classes.leftIcon} />
          Produit précedent
        </Button>
        <ItemsCounter>
          {`${currentIndex + 1} / ${commands[commandIndex].items.length}`}
        </ItemsCounter>
        <Button
          color="primary"
          disabled={commands[commandIndex].items.length - 1 === currentIndex}
          onClick={nextItems}
        >
          Produit suivant
          <ChevronRightIcon className={classes.rightIcon} />
        </Button>
      </ButtonContainer>
    </form>
  );
};

const mapStateToProps = state => ({
  commands: state.importCommands.commands
});

EditCommandItems = reduxForm({
  form: 'editCommand',
  validate
})(EditCommandItems);

EditCommandItems.propTypes = {
  commandIndex: PropTypes.number.isRequired,
  commands: PropTypes.array.isRequired
};

export default connect(mapStateToProps)(EditCommandItems);
